
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqaDsikUj4aN1Nlrfq69x52yx5ACzupE1fdqNE9aNPjysMeta } from "/codebuild/output/src3991734491/src/src/pages/faq.vue?macro=true";
import { default as menuL9PPbneudnctpCAFo46SzMs_fSqRe7dgEeVq7Zb4OWwMeta } from "/codebuild/output/src3991734491/src/src/pages/menu.vue?macro=true";
import { default as indexEqS_ceUDlm524QjBPHDLZZHgM1j5ICTshDTA4o6RxnwMeta } from "/codebuild/output/src3991734491/src/src/pages/index.vue?macro=true";
import { default as contacttqlJSwOfi1PL7ScIvGm1wFVwaX2e3tLV_45FGcS1axX6UMeta } from "/codebuild/output/src3991734491/src/src/pages/contact.vue?macro=true";
import { default as tutorialX1C23SQHZUg4uzwkINTveeQO0U_Ie3l9F8auuiWlPncMeta } from "/codebuild/output/src3991734491/src/src/pages/tutorial.vue?macro=true";
import { default as agreementvNiKbPV5DIM7qzd3keuTy1nvf2gtntgqkASuxf1G4Y0Meta } from "/codebuild/output/src3991734491/src/src/pages/agreement.vue?macro=true";
import { default as about_45passL5_45ej1vePdZRT61NYo4KSAQ_45x1kAGMZ8flnp7wXR4HMMeta } from "/codebuild/output/src3991734491/src/src/pages/about-pass.vue?macro=true";
import { default as indexA3Hy3wc4SFIBDFasaQ7Sbo9IL_gw7h6pe0wenS0zLgQMeta } from "/codebuild/output/src3991734491/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93m4BkjmzaKM2Ymh7N_45DG2LzpNyqqZjYp0BIuam6_60ZUMeta } from "/codebuild/output/src3991734491/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceZMR35sJmtkHLmDpb8B8RP3nAWju9k0lQCCmw5E1MDXcMeta } from "/codebuild/output/src3991734491/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93YHXlPnEKpBXjyqimgeDDlKfubrAak3oKKMsMZUUE8VMMeta } from "/codebuild/output/src3991734491/src/src/pages/notice/[id].vue?macro=true";
import { default as indexHYg0yi3FkkiLsgGYeH65zX65NCpbog8BVSKIB34rVWsMeta } from "/codebuild/output/src3991734491/src/src/pages/coupon/index.vue?macro=true";
import { default as indexYAB2B8Kytf5J_45oM32q3Ga7PXVxN9JZ7kQmHcPjpkjD4Meta } from "/codebuild/output/src3991734491/src/src/pages/mypage/index.vue?macro=true";
import { default as indexKpDzbPa1aCGiilI1pD83E66RGnfdYDBoeakvgk8OBj4Meta } from "/codebuild/output/src3991734491/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93GYKJgkPLWcX1EsvJqIA_45noNTXiHg_45DmVeOCgshRCXwMMeta } from "/codebuild/output/src3991734491/src/src/pages/parking/[id].vue?macro=true";
import { default as indexUrt5mwqGo2gbLByc2GcuxSpiCvQv6Ri82ZM2RAm_XJYMeta } from "/codebuild/output/src3991734491/src/src/pages/history/index.vue?macro=true";
import { default as index9wkvvREeagCcjWTiwrnIa8Fl5hf4P9rRozFjutfVNE4Meta } from "/codebuild/output/src3991734491/src/src/pages/monthly/index.vue?macro=true";
import { default as index6qiqaeComq_08YGTio3S3oJ0jllg_457nBjqipurMTOMEMeta } from "/codebuild/output/src3991734491/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexogjU_jlmCX1MxB4YuhVpSY2X8Dk5ShJE49LXal9DODwMeta } from "/codebuild/output/src3991734491/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviaez7Yt6K5Qol5tDj2_45z9Vro0BhgFqtd9kCizcWExoBAMeta } from "/codebuild/output/src3991734491/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editE8Rlbu4jL5E3LRNa_P5a9LuFhJMhAWhAFutyXeS9XmEMeta } from "/codebuild/output/src3991734491/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementUWz76HAsYk899uOFbjpWrkbflh_5xtp3MxkF8GHg_dUMeta } from "/codebuild/output/src3991734491/src/src/pages/pass-agreement.vue?macro=true";
import { default as index7MJ__sqhAjZUCk1pJA3qw9xpoAUwa8PqaqOiTv4IQFUMeta } from "/codebuild/output/src3991734491/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453d7Ea2OqCSXVC2mEiEpw933V03e0WgnCePxTZEDBmR62sMeta } from "/codebuild/output/src3991734491/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmTTUpoPCnfClTpV_h_45swm7GNwJA2qzZAYHH6fnpx15yMMeta } from "/codebuild/output/src3991734491/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexqA_45h05PcoAN089oONsYTHjFU9qUXJSg4fbkCAjrUeFsMeta } from "/codebuild/output/src3991734491/src/src/pages/card/create/index.vue?macro=true";
import { default as indexAbnyP7OacN1OqQst2SJ0OyW1VRYH522DuosDKz3blGUMeta } from "/codebuild/output/src3991734491/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmkbiO5tcrckRh9n68y2LqIXZTn5mapXJgxxmju2S33MgMeta } from "/codebuild/output/src3991734491/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmiheA7VSYhAJ7QICIeN9uLMylGwLeYBx_45Jazr27Tb508Meta } from "/codebuild/output/src3991734491/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completetT_45Q9kVVQEQzt8wS6sIqtiwl3BlK3F_454JqqVisTLqsgMeta } from "/codebuild/output/src3991734491/src/src/pages/membership/complete.vue?macro=true";
import { default as registerhTd9vBv7tAYO0v6oA8Us8WsvlQusCxOeAfNmC_45h4i_454Meta } from "/codebuild/output/src3991734491/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93Hy57umRvSr_45yHAsuEfRXRaUowSmS21Rmh3QdBxbyUoQMeta } from "/codebuild/output/src3991734491/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirm1Qt7qgdRA_YLp_45tVbVWTE8iVtpo_KB1d6L3_459mDeezMMeta } from "/codebuild/output/src3991734491/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93OdkvgWjX4jc12ITqtVoApoHIa7Oj69hWVVmcXXBiq_0Meta } from "/codebuild/output/src3991734491/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexIPOTiRg88kDiag7TmA5LRWqixhEeaNYLKlrtGhIW2hMMeta } from "/codebuild/output/src3991734491/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeG4woTfmWIVq3lGW9iLeOKzgqlZlpH1TATGYHGH6JRr0Meta } from "/codebuild/output/src3991734491/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code4x5rK3f_456UwpTIupx1_457nOQ0nRnI4NiqcVcfPuucZ4AMeta } from "/codebuild/output/src3991734491/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeXdCPTBJ3JCQwcx5O6oW5IlUBL_4jQdtxHojVEfLrT7MMeta } from "/codebuild/output/src3991734491/src/src/pages/contact-form/complete.vue?macro=true";
import { default as register9TeXwG_zRnRB5WWRgmpnDQw6lOM79KibeAF5D3xxyZ8Meta } from "/codebuild/output/src3991734491/src/src/pages/contact-form/register.vue?macro=true";
import { default as completewgeWihIcqHShrs0UwQKxMQYQm8_8JWNgbpyRk3QuraUMeta } from "/codebuild/output/src3991734491/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexq_458205dUE3lbUETyBsK6X1yDVVIQuZcSVsVYUf2VaFAMeta } from "/codebuild/output/src3991734491/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmq3TOtcvJ100Iu8SS7AcU_45rm46uyH5aeXwE7E4jG9fR8Meta } from "/codebuild/output/src3991734491/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeVVRG4rZeMR42lGX3ktH5R7OViRup6MTuOkQSvPMpUGIMeta } from "/codebuild/output/src3991734491/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexxi3OHaOzmopAZGo8UsHSWCh_45w_RDYSRvnx54CrU0R4wMeta } from "/codebuild/output/src3991734491/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93oRK30qzHBIhSCl93JQhnku_45PPTYrlHwCDnLOY2x_452CMMeta } from "/codebuild/output/src3991734491/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completetcyM0I22_45eEpF7YQsJfIertjcx5KmogJ2VwLpnyYO98Meta } from "/codebuild/output/src3991734491/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasGyia8ryqssRi7O5T8dI91IEhjk_9bbl_Ol517gbCeecMeta } from "/codebuild/output/src3991734491/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sample_94Vs9AclrBnbvenwM48Thr2mfXaPjYZ_OWQSctrZksMeta } from "/codebuild/output/src3991734491/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailAoTc3wsJ5zcBBTFnYHrQQkN1n4cTmkRRnxFJWFcjrSYMeta } from "/codebuild/output/src3991734491/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmradn7bGn6rJ06__45n9aG_45haYHXc0rRqrC9Nnv5c_45PzqYMeta } from "/codebuild/output/src3991734491/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentHMX1RjMdQIfHKF7qilq6PwYHqF00Pd8MFXteAvwdRI4Meta } from "/codebuild/output/src3991734491/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmIoxzTxTcvVYAxW1sldCN7oIL0BlJjNFQb3E4c56l7xgMeta } from "/codebuild/output/src3991734491/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate2_R_qb4Hlt7bOJw3e29wp5tLD8B5i0ShO_zkXqu3uTkMeta } from "/codebuild/output/src3991734491/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeKlMtDtWhRGtpg3cb6NWcUKWSIir01qufDpCuU7kbl9UMeta } from "/codebuild/output/src3991734491/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codevLo9bCRnLWwXzpUYIeGRtiyQX0qEdo2NHvYFNjML5aoMeta } from "/codebuild/output/src3991734491/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordUa_45xmcU5zXbFYFu8QwAgPP06ZfSnsw2s_45_45eZ0_fT6j0Meta } from "/codebuild/output/src3991734491/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45alias7gP87nNu5UAQQ1LDRMX6KDW070K5RgLqjwBBgSLMYcEMeta } from "/codebuild/output/src3991734491/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registertRTLxa760UF8PFjxIwxzI2nd7wJv4QPVnwqNSCpa8vQMeta } from "/codebuild/output/src3991734491/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeh1pzMz4qleiPnFJCEAaFkLegRoiskUPbTiAKvvYFcq8Meta } from "/codebuild/output/src3991734491/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexvDm45efiTMzlnOw8CF87cvAWjMmnv_0GKMqc3_45627ccMeta } from "/codebuild/output/src3991734491/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexjgiLWrex761pGpeHqhllsqmZnkyMLXdymKG6tf16UUwMeta } from "/codebuild/output/src3991734491/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index_45U4E9SPrGQUQI5k7_45OH3OaWRloBgAjMnwq5Fz_ffSkMMeta } from "/codebuild/output/src3991734491/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexr0miEm_45QFMGAT4V2Urh_HL8Ok7kzHtJ0Y3srK4O8KagMeta } from "/codebuild/output/src3991734491/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateT83vkiaoJ168PPBFC_453dihbGvrg9GR0FHhRz1_IzKMoMeta } from "/codebuild/output/src3991734491/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeCEIKTi_4580kCfq21Z1aXP20ZDq6GA1F66c5Umz_45C4PK0Meta } from "/codebuild/output/src3991734491/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirm_45KFuDPMtJd5R2MiB_QMsjwkhsZBgsfleCnbDzNplG4AMeta } from "/codebuild/output/src3991734491/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as index6a1f_451AUiyWqH7lVRwt5ZLvl4zNrJowgxRzri_453N2jkMeta } from "/codebuild/output/src3991734491/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete7CZaWgvWJ5RDQb07FlUWi808CGfoQcj7hoanHG7re70Meta } from "/codebuild/output/src3991734491/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatetsAw4Tr_XTkCGiny2bzEmZckCixur_HO1qn1nqRz_gEMeta } from "/codebuild/output/src3991734491/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexKniAwtBBHMrvAfRSOr9fGLpRI5sF7Oakij8dZQz0b9QMeta } from "/codebuild/output/src3991734491/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexMlV2aVxOt7Yd3g4m17ibGDGxG8mCj_7Zj2qEgZSO9G8Meta } from "/codebuild/output/src3991734491/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completejv_dvWaLB0uB0y4U4XwcAsMh_45MdAEfgk1AM5P87hLE0Meta } from "/codebuild/output/src3991734491/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexKsD0wc_0yRIo_45UMAHtXZ1MjnugUEEYaBq5cXigeOva0Meta } from "/codebuild/output/src3991734491/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeoxhnuw5MjtQAVTMA43AeF__wRyw8ZCplckE0OR6PPpIMeta } from "/codebuild/output/src3991734491/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexX3vXfJziOFXs352QcvijjKy3FexirNr1CYqcWqI3Q_45IMeta } from "/codebuild/output/src3991734491/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexpKibwhMYfIvZIKJzJ_tMJ9dTR26fEfSvZjIwck2mDJAMeta } from "/codebuild/output/src3991734491/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexSqBPJ4XPEAzNDzSwRseCVkzcbxpkj9l6e130kw74HNMMeta } from "/codebuild/output/src3991734491/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateiHLc31ieuTIgcFwJ0Zo8_451nrQDtZ2axWwn_dL6hATdoMeta } from "/codebuild/output/src3991734491/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmB77LBNJXw59FZIWyU99OFPvpNFKl_45ve1XYCSVPJ_45siUMeta } from "/codebuild/output/src3991734491/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuL9PPbneudnctpCAFo46SzMs_fSqRe7dgEeVq7Zb4OWwMeta || {},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexEqS_ceUDlm524QjBPHDLZZHgM1j5ICTshDTA4o6RxnwMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src3991734491/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexHYg0yi3FkkiLsgGYeH65zX65NCpbog8BVSKIB34rVWsMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3991734491/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexUrt5mwqGo2gbLByc2GcuxSpiCvQv6Ri82ZM2RAm_XJYMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3991734491/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: index6qiqaeComq_08YGTio3S3oJ0jllg_457nBjqipurMTOMEMeta || {},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexogjU_jlmCX1MxB4YuhVpSY2X8Dk5ShJE49LXal9DODwMeta || {},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexqA_45h05PcoAN089oONsYTHjFU9qUXJSg4fbkCAjrUeFsMeta || {},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmkbiO5tcrckRh9n68y2LqIXZTn5mapXJgxxmju2S33MgMeta || {},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmiheA7VSYhAJ7QICIeN9uLMylGwLeYBx_45Jazr27Tb508Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3991734491/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completetT_45Q9kVVQEQzt8wS6sIqtiwl3BlK3F_454JqqVisTLqsgMeta || {},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerhTd9vBv7tAYO0v6oA8Us8WsvlQusCxOeAfNmC_45h4i_454Meta || {},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirm1Qt7qgdRA_YLp_45tVbVWTE8iVtpo_KB1d6L3_459mDeezMMeta || {},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeG4woTfmWIVq3lGW9iLeOKzgqlZlpH1TATGYHGH6JRr0Meta || {},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code4x5rK3f_456UwpTIupx1_457nOQ0nRnI4NiqcVcfPuucZ4AMeta || {},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeXdCPTBJ3JCQwcx5O6oW5IlUBL_4jQdtxHojVEfLrT7MMeta || {},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: register9TeXwG_zRnRB5WWRgmpnDQw6lOM79KibeAF5D3xxyZ8Meta || {},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmq3TOtcvJ100Iu8SS7AcU_45rm46uyH5aeXwE7E4jG9fR8Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeVVRG4rZeMR42lGX3ktH5R7OViRup6MTuOkQSvPMpUGIMeta || {},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexxi3OHaOzmopAZGo8UsHSWCh_45w_RDYSRvnx54CrU0R4wMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completetcyM0I22_45eEpF7YQsJfIertjcx5KmogJ2VwLpnyYO98Meta || {},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sample_94Vs9AclrBnbvenwM48Thr2mfXaPjYZ_OWQSctrZksMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailAoTc3wsJ5zcBBTFnYHrQQkN1n4cTmkRRnxFJWFcjrSYMeta || {},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmradn7bGn6rJ06__45n9aG_45haYHXc0rRqrC9Nnv5c_45PzqYMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentHMX1RjMdQIfHKF7qilq6PwYHqF00Pd8MFXteAvwdRI4Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmIoxzTxTcvVYAxW1sldCN7oIL0BlJjNFQb3E4c56l7xgMeta || {},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeKlMtDtWhRGtpg3cb6NWcUKWSIir01qufDpCuU7kbl9UMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codevLo9bCRnLWwXzpUYIeGRtiyQX0qEdo2NHvYFNjML5aoMeta || {},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordUa_45xmcU5zXbFYFu8QwAgPP06ZfSnsw2s_45_45eZ0_fT6j0Meta || {},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registertRTLxa760UF8PFjxIwxzI2nd7wJv4QPVnwqNSCpa8vQMeta || {},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeh1pzMz4qleiPnFJCEAaFkLegRoiskUPbTiAKvvYFcq8Meta || {},
    component: () => import("/codebuild/output/src3991734491/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3991734491/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]